export type NewsletterKey = 'ApiError' | 'SelectNewsletters' | 'NoNewsletterSelected' | 'Subscribe' | 'SignupSuccess';

interface DictionaryFunctions {
	get(key: NewsletterKey): string;
}

export const NewsletterItems = (getValue: (key: string, defaultValue?: string) => string): DictionaryFunctions => {
	return {
		get: (key: NewsletterKey): string => {
			switch (key) {
				case 'ApiError':
					return getValue('Newsletter.ApiError', 'Der er opstået en fejl.');
				case 'NoNewsletterSelected':
					return getValue('Newsletter.NoNewsletterSelected', 'Du skal vælge mindst ét nyhedsbrev.');
				case 'Subscribe':
					return getValue('Newsletter.Subscribe', 'Tilmeld');
				case 'SignupSuccess':
					return getValue('Newsletter.SignupSuccess', 'Du er nu tilmeldt de valgte nyhedsbreve.');
				case 'SelectNewsletters':
					return getValue('Newsletter.SelectNewsletters', 'Vælg dit abonnement');
			}
		},
	};
};
